exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".card[data-v-193c4b1c]{overflow:hidden}p[data-v-193c4b1c]{word-wrap:break-word}.close-btn[data-v-193c4b1c]{top:8px;right:8px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/AuditModal.vue"],"names":[],"mappings":"AACA,uBACE,eAAiB,CAClB,AACD,mBACE,oBAAsB,CACvB,AACD,4BACE,QAAS,AACT,SAAW,CACZ","file":"AuditModal.vue","sourcesContent":["\n.card[data-v-193c4b1c] {\n  overflow: hidden;\n}\np[data-v-193c4b1c] {\n  word-wrap: break-word;\n}\n.close-btn[data-v-193c4b1c] {\n  top: 8px;\n  right: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-193c4b1c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/AuditModal.vue
// module id = 517
// module chunks = 6